module.exports = __webpack_public_path__ + "static/media/1013974.8cd02cc5.png";